import React, { useEffect, useState } from 'react'
import {
    PiCaretDownFill,
    PiCaretUpFill,
    PiCheckCircleFill,
    PiWarningFill,
  } from "react-icons/pi";
import { debittingCountApi, faAppReport, mailReportApi, mailworkFlowReportApi, smsworkFlowReportApi, workFlowReportApi } from '../services';
import moment from 'moment';
import { useNavigate, useParams } from 'react-router';

const WorkFlowReport = () => {

    const [faReport, setFaReport] = useState([])
    const [smsReport, setSmsReport] = useState([])
    const [mailReport, setMailReport] = useState([])
    const [loading, setLoading] = useState(false)
    const {id} = useParams()
    const navigate = useNavigate()

    const WORKFLOWSTATUS = {
        BILLER_INITIATED: 1,
        BILLER_AUTHORISED: 2,
        BILLER_REJECTED: 3,
        BILLER_APPROVED: 4,
        BANK_AUTHORIZED: 6,
        BANK_REJECTED: 7,
        BANK_APPROVED: 8,
        BANK_DISAPPROVED: 9,
      };
      
      function getWorkflowStatusLabel(statusCode) {
        const entry = Object.entries(WORKFLOWSTATUS).find(
          ([_, value]) => value === statusCode
        );
      
        if (!entry) return "Unknown Status";
      
        // Convert key to readable format e.g., BILLER_INITIATED => Biller Initiated
        const formatted = entry[0]
          .toLowerCase()
          .split('_')
          .map(word => word.charAt(0).toUpperCase() + word.slice(1))
          .join(' ');
      
        return formatted;
      }
      

    const numberFormat = (value, toFixed = 2) => {
        const num = Number(value);
        if (Number.isInteger(num)) {
          return num.toLocaleString(); // Handles integer values without decimals
        } else {
          return num
            .toFixed(toFixed) // Ensures the specified number of decimal places
            .replace(/\d(?=(\d{3})+\.)/g, "$&,"); // Adds commas for thousands
        }
      };

      const handleWorkFlow = async () =>{
        await workFlowReportApi(id)
            .then((res)=>{
                setFaReport(res?.data)
                // setFaReport(res?.data)
            })
            .catch((err) =>{
                console.log('err ', err);
            })
      }

      const handleSmsReport = async () =>{
        await smsworkFlowReportApi(id)
            .then((res)=>{
              // console.log("sms res ", res?.data);
                setSmsReport(res?.data)
                // setFaReport(res?.data)
            })
            .catch((err) =>{
                console.log('err ', err);
            })
      }

      const handleMailReport = async () =>{
        await mailworkFlowReportApi(id)
            .then((res)=>{
              // console.log("mail res ", res?.data);
                setMailReport(res?.data)
                // setFaReport(res?.data)
            })
            .catch((err) =>{
                console.log('err ', err);
            })
      }


      useEffect(()=>{
        const initiate = async () =>{
            setLoading(true)
            await handleWorkFlow()
            await handleSmsReport()
            await handleMailReport()
            setLoading(false)
        }
        initiate()
      },[])

  return (
    <>
      {loading ? (
        <div className="typewriter-container">
          <div class="typewriter">
            <div class="slide">
              <i></i>
            </div>
            <div class="paper"></div>
            <div class="keyboard"></div>
          </div>
          <code style={{ color: "#000" }}>Getting your app ready...</code>
        </div>
      ) : (
    <div>

        {/* <h5 className='mt-3'>WorkFlow Report</h5>
        <div
        className="d-flex align-items-center gap-3 flex-wrap"
        style={{ height: "98px" }}
      >
        {faReport?.map((item, index)=> <div key={index}
          className=" h-150 rounded p-2 d-flex align-items-center justify-content-between flex-direction-row"
          style={{ border: "1px solid #d4d4d8", minWidth: '350px' }}
        >
          <div>
          <p className="mb-1 text-muted"><span style={{fontWeight: "bold"}}>WorkFlow status:</span> {getWorkflowStatusLabel(Number(item?.workFlowStatus))}</p>
            {item?.workFlowStatusDescription && <p className="mb-3 text-muted">Description: {item?.workFlowStatusDescription ?? "Error"}</p>}
            <h4 className="mb-0" style={{ color: "#000" }}>
              {numberFormat(item?.count)}
            </h4>
          </div>

          <div
            className="rounded-circle d-flex align-items-center justify-content-center"
            style={{
              width: "35px",
              height: "35px",
              backgroundColor: "#e6f2fa",
            }}
          >
            <PiCheckCircleFill
              style={{ fontSize: "2.1rem" }}
              className="text-primary"
            />
          </div>
        </div>)}
        
      </div> */}

      <h5 className='mt-3'>Workflow Status</h5>
                <table className="fl-table">
                  <thead>
                    <tr style={{ borderBottom: "0.5px solid #f1f1f1" }}>
                      {/* Table header cells */}
                      {/* Modify according to your data structure */}
                      <th width="20%">WorkFlow Status</th>
                      <th>WorkFlow Description</th>
                      <th>Count</th>
                    </tr>
                  </thead>
                  <tbody>
                    {
                      faReport?.map((mandate, index) => (
                        <tr
                          className="hover-detail"
                          key={index}
                          onClick={() => {
                            navigate(`/all-mandates/${id}/${mandate?.workFlowStatus}`)
                          }}
                        >
                          <td className="gray-td">{mandate?.workFlowStatus}</td>
                          <td className="gray-td">{mandate?.workFlowStatusDescription}</td>
                          <td className="gray-td">{mandate?.count}</td>
                        </tr>
                      ))}
                  </tbody>
                </table>

      <h5 className='mt-3'>Sms Report</h5>
                <table className="fl-table">
                  <thead>
                    <tr style={{ borderBottom: "0.5px solid #f1f1f1" }}>
                      {/* Table header cells */}
                      {/* Modify according to your data structure */}
                      <th width="20%">Date Sent</th>
                      <th width="20%">Level</th>
                      <th>Pending</th>
                      <th>Sent</th>
                      <th>Total</th>
                      <th>Vanso Delivery report</th>
                      <th>Vanso Enroute</th>
                      <th>Vanso Undelivered</th>
                      <th>Vanso Expired</th>
                    </tr>
                  </thead>
                  <tbody>
                    {
                      smsReport?.map((mandate) => (
                        <tr
                          className="tr"
                          key={mandate.id}
                          
                        >
                          <td className="gray-td">{moment(mandate?.date).format('DD MMM, YYYY')}</td>
                          <td className="gray-td">{mandate?.level}</td>
                          <td className="gray-td">{mandate?.pending}</td>
                          <td className="gray-td">{mandate?.sent}</td>
                          <td className="gray-td">{mandate?.total}</td>
                          
                          <td className="gray-td hover-detail" onClick={() => {
                            navigate(`/all-sms-logs/${id}`, {
                              state: { level: mandate?.level, date: mandate?.date, sentStatus: "delivered" }
                            })
                          }}>{mandate?.deliveryReport}</td>
                          <td className="gray-td important-gold  hover-detail" style={{color: "#BA8E23"}} onClick={() => {
                            navigate(`/all-sms-logs/${id}`, {
                              state: { level: mandate?.level, date: mandate?.date, sentStatus: "enroute" }
                            })
                          }}>{mandate?.vansoEnroute}</td>
                          <td className="gray-td important-red  hover-detail" onClick={() => {
                            navigate(`/all-sms-logs/${id}`, {
                              state: { level: mandate?.level, date: mandate?.date, sentStatus: "undeliverable" }
                            })
                          }}>{mandate?.vansoUndeliverable}</td>
                          <td className="gray-td important-red">{mandate?.vansoExpired}</td>
                        </tr>
                      ))}
                  </tbody>
                </table>

                <h5 className='mt-3'>Mail Report</h5>
                <table className="fl-table">
                  <thead>
                    <tr style={{ borderBottom: "0.5px solid #f1f1f1" }}>
                      {/* Table header cells */}
                      {/* Modify according to your data structure */}
                      <th width="20%">Date Sent</th>
                      <th width="20%">Level</th>
                      <th>Sent</th>
                      <th>Failed</th>
                      <th>Total</th>
                    </tr>
                  </thead>
                  <tbody>
                    {
                      mailReport?.map((mandate) => (
                        <tr
                          className="tr"
                          key={mandate.id}
                        >
                          <td className="gray-td">{moment(mandate?.date).format('DD MMM, YYYY')}</td>
                          <td className="gray-td">{mandate?.level}</td>
                          <td className="gray-td">{mandate?.sent}</td>
                          <td className="gray-td">{mandate?.failed}</td>
                          <td className="gray-td">{mandate?.total}</td>
                        </tr>
                      ))}
                  </tbody>
                </table>
    </div>
      )}
      </>
  )
}

export default WorkFlowReport